export const cardIssuersConstants = {
  GET_CARDISSUERS_REQUEST: "GET_CARDISSUERS_REQUEST",
  GET_CARDISSUERS_SUCCESS: "GET_CARDISSUERS_SUCCESS",
  GET_CARDISSUERS_FAILURE: "GET_CARDISSUERS_FAILURE",
  GET_CARDISSUERS_RESET: "GET_CARDISSUERS_RESET",

  VIEW_CARDISSUER_REQUEST: "VIEW_CARDISSUER_REQUEST",
  VIEW_CARDISSUER_SUCCESS: "VIEW_CARDISSUER_SUCCESS",
  VIEW_CARDISSUER_FAILURE: "VIEW_CARDISSUER_FAILURE",
  VIEW_CARDISSUER_RESET: "VIEW_CARDISSUER_RESET",

  ADD_CARDISSUER_REQUEST: "ADD_CARDISSUER_REQUEST",
  ADD_CARDISSUER_SUCCESS: "ADD_CARDISSUER_SUCCESS",
  ADD_CARDISSUER_FAILURE: "ADD_CARDISSUER_FAILURE",
  ADD_CARDISSUER_RESET: "ADD_CARDISSUER_RESET",

  EDIT_CARDISSUER_REQUEST: "EDIT_CARDISSUER_REQUEST",
  EDIT_CARDISSUER_SUCCESS: "EDIT_CARDISSUER_SUCCESS",
  EDIT_CARDISSUER_FAILURE: "EDIT_CARDISSUER_FAILURE",
};
